export default [{
  path: '/departamentos',
  component: {
    name: 'departamentosBase',
    template: '<router-view />',
    meta: {
      resource: 'departamento',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'departamentos',
    component: () => import('@/app-modulo/comuns/departamentos/DepartamentoView.vue'),
    meta: {
      resource: 'departamento',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'departamentos',
      pageTitle: 'Cadastro de departamentos',
      breadcrumb: [
        {
          text: 'Departamentos',
          to: { name: 'departamentos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-departamento',
    component: () => import('@/app-modulo/comuns/departamentos/shared/components/cadastro/Departamento.vue'),
    meta: {
      resource: 'departamento',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'departamentos',
      pageTitle: 'Cadastro de departamentos',
      breadcrumb: [
        {
          text: 'Departamentos',
          to: { name: 'departamentos' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-departamento' },
          active: true,
        },
      ],
    },
  }, {
    path: 'editar/:id',
    name: 'editar-departamento',
    component: () => import('@/app-modulo/comuns/departamentos/shared/components/cadastro/Departamento.vue'),
    meta: {
      resource: 'departamento',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'departamentos',
      pageTitle: 'Cadastro de departamentos',
      breadcrumb: [
        {
          text: 'Departamentos',
          to: { name: 'departamentos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-departamento' },
          active: true,
        },
      ],
    },
  }],
},
]
